var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquareHalf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.02381 3C3.01066 3 3 3.01066 3 3.02381V12.9762C3 12.9893 3.01066 13 3.02381 13H7.5V3H3.02381ZM3.02381 2C2.45837 2 2 2.45838 2 3.02381V12.9762C2 13.5416 2.45837 14 3.02381 14H12.9762C13.5416 14 14 13.5416 14 12.9762V3.02381C14 2.45837 13.5416 2 12.9762 2H3.02381ZM8.5 3V4.125H13V3.02381C13 3.01066 12.9893 3 12.9762 3H8.5ZM13 5.125H8.5V6.375H13V5.125ZM13 7.375H8.5V8.625H13V7.375ZM13 9.625H8.5V10.875H13V9.625ZM13 11.875H8.5V13H12.9762C12.9893 13 13 12.9893 13 12.9762V11.875Z",
    fill: "#393A40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareHalf);
export default __webpack_public_path__ + "static/media/squareHalf.00e1da75c39b4991abbb5dc66831e91d.svg";
export { ForwardRef as ReactComponent };